import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ADMIN_PATH, ADMIN_SECRET_PATH } from "@/lib/api";
import { SecurityShield } from "@/components/SecurityShield";
import { BrowserGate } from "@/components/BrowserGate";
import Landing from "@/pages/Landing";
import Legal from "@/pages/Legal";
import StaffPortal from "@/pages/StaffPanel";
import AdminPortal from "@/pages/AdminPanel";
import CustomerPanel from "@/pages/CustomerPanel";

const CustomerRoute = () => {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-[var(--muted-text)]">ലോഡ് ചെയ്യുന്നു...</div>;
  if (!user || user.role !== "customer") return <Navigate to="/" replace />;
  return <CustomerPanel />;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SecurityShield>
          <BrowserGate />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/customer" element={<CustomerRoute />} />
              <Route path="/staff" element={<StaffPortal />} />
              <Route path={ADMIN_PATH} element={<AdminPortal />} />
              <Route path={ADMIN_SECRET_PATH} element={<AdminPortal />} />
              <Route path="/terms" element={<Legal kind="terms" />} />
              <Route path="/privacy" element={<Legal kind="privacy" />} />
              <Route path="/refund" element={<Legal kind="refund" />} />
              <Route path="/fund" element={<Legal kind="fund" />} />
              <Route path="/staff-rules" element={<Legal kind="staff" />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </SecurityShield>
        <Toaster position="top-center" richColors theme="dark" />
      </AuthProvider>
    </div>
  );
}

export default App;
